import { useContext, useEffect, useMemo, useReducer, useRef, useState } from "react";
import { DisplayUserPicAndName, FormatTimePassedUtc, ItemID, } from "../newComponents/GeneralClasses";
import { HbrAvatarProfile,HbrCancel,HbrMoreVert, HbrSendIcon, HbrStarIcon } from "../newComponents/Mycustomsvgicons";
import { collection, deleteDoc, doc, onSnapshot, orderBy, query, setDoc, where } from "firebase/firestore";
import ReplyReviewContent from "./ReplyReviewContent";
import db from "../firebase";
import { actionConsts, reducer } from "../newComponents/StateManager";
import { AuthContext } from "../AuthContext";
import CustomTextArea from "./CustomTextArea";
import { useNavigate } from "react-router-dom";

const ReviewContent = ({userName: userNameOnReview, email, message, book_title, country, rate, timestamp, reviewID}) => {
    const [profile_pic, setProfilePic] = useState("");
    const [userNameToDisplay, setUserNameToDisplay] = useState("");
    const [replies,setReplies] = useState([]);
    const [showReplyContent, setShowReplyContent] = useState(false);
    const {user_email} = useContext(AuthContext);
    const {userName} = useContext(AuthContext);
    const [state, dispatch]=useReducer(reducer,{showMenu: false, showDelete: false, showReplyBox: false, replyText: "", sendingTask: false});
    const menuRef = useRef(null);
    const replyBoxRef = useRef(null);
    const repliesViewRef = useRef(null);
    const navigate = useNavigate();

    useEffect(()=>{
        async function getUserInfo() {
            const userInfo = await DisplayUserPicAndName(email);
            if (userInfo) {
                const nameFromDB = userInfo.name && userInfo.name !== "" ? userInfo.name : userNameOnReview;
                setUserNameToDisplay(nameFromDB);
                setProfilePic(userInfo.profilePic);
            };
        }
        getUserInfo();
    },[email, userNameOnReview]);


    useEffect(()=>{

        if (reviewID) {
            const collectionRef = collection(db, "reply reviews");
            const q = query(collectionRef, orderBy("timestamp","desc"), where("reviewID","==",reviewID));
            const unsub = onSnapshot(q, (snapshot)=>{
                const newRepliesArray = [];
                snapshot.forEach((doc)=>{
                    newRepliesArray.push(doc.data());
                });
                setReplies(newRepliesArray);
            });
            return unsub;
        }
 
    },[reviewID]);

    const memoizedReplies = useMemo(()=>replies,[replies]);

    useEffect(()=>{
        if (state.showMenu || state.showReplyBox || showReplyContent) {
            const menuOutsideTouchable=(e)=>{
                if (menuRef.current) {
                    if (!menuRef.current.contains(e.target)) {
                        dispatch({type: actionConsts.SHOW_MENU, payload: false});
                    }
                }
            };
            const dismissReplyBox=(e)=>{
                if (replyBoxRef.current) {
                    if (!replyBoxRef.current.contains(e.target)) {
                        dispatch({type: actionConsts.SHOW_REPLY_BOX, payload: false});
                        dispatch({type: actionConsts.REPLY_TEXT, payload: ""});
                    }
                }
            };
            const dismissRepliesView=(e)=>{
                if (repliesViewRef.current) {
                    if (!repliesViewRef.current.contains(e.target)) {
                        setShowReplyContent(false);
                    }
                }
            };

            document.addEventListener("mousedown", menuOutsideTouchable);
            document.addEventListener("mousedown", dismissReplyBox);
            document.addEventListener("mousedown", dismissRepliesView);
            return()=> {
                document.removeEventListener("mousedown", menuOutsideTouchable); 
                document.removeEventListener("mousedown", dismissReplyBox); 
                document.removeEventListener("mousedown", dismissRepliesView); 
            }   
        }
    },[state.showMenu, state.showReplyBox, showReplyContent]);

    useEffect(()=>{
        if (email === user_email) {
            dispatch({type: actionConsts.SHOW_DELETE, payload: true});
        }else{
            dispatch({type: actionConsts.SHOW_DELETE, payload: false});
        }
    },[email, user_email]);

    const toggleMenuVisibility=()=>{
        dispatch({type: actionConsts.SHOW_MENU, payload: true});
    };

    const deleteReview=async()=>{
        if (email === user_email) {
            const docRef = doc(db,"book reviews",reviewID);
            await deleteDoc(docRef);
            dispatch({type: actionConsts.SHOW_MENU, payload: false});
        }
    };

    const handleShowReply=()=>{
        dispatch({type: actionConsts.SHOW_REPLY_BOX, payload: true});
        dispatch({type: actionConsts.SHOW_MENU, payload: false});
    };

    const sendReply=async()=>{
        dispatch({type: actionConsts.SENDING_TASK, payload: true});
        const reply_id = ItemID();
        const timestamp = new Date().getTime();
        await setDoc(doc(db,"reply reviews", reply_id),{
            name: userName,
            email: user_email,
            message: state.replyText,
            replyID: reply_id,
            reviewID,
            userReplied: userNameOnReview,
            timestamp
        });
        dispatch({type: actionConsts.SENDING_TASK, payload: false});
        dispatch({type: actionConsts.SHOW_REPLY_BOX, payload: false});
        dispatch({type: actionConsts.REPLY_TEXT, payload: ""});
    };



    return ( 
        <div className="reviewcontent flex-column1">
                 {state.sendingTask && 
                    <div className="linearprogressindicator">
                    <div className="linearprogressbar"></div>
                    </div>
                }

            <div className="flex-spacebetween" style={{width:"100%"}}>
                <div className="reviewtopuserinfo flex-row2" style={{gap:"10px"}}>

                    {profile_pic && profile_pic !== "" ? (
                        <img src={profile_pic} alt="" style={{width:"2em", height:"2em", objectFit:"cover", borderRadius:"50%"}}/>
                    ):(
                    <div><HbrAvatarProfile width={"2em"} height={"2em"}/></div>
                    )}

                    <h4 style={{fontWeight:"bold"}}>{userNameToDisplay}</h4>
                    <h5 style={{fontWeight:"bold"}}>{country}</h5>
                    <p>{FormatTimePassedUtc(timestamp)}</p>
                </div>

                <div style={{position:"relative"}}>
                     <HbrMoreVert width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>toggleMenuVisibility()}/>

                    {state.showMenu && 
                        <div className="reviewcontentmenuitems flex-column1" ref={menuRef}>
                            <button onClick={()=>handleShowReply()}>Reply</button>
                            <button onClick={()=>navigate("/contact")}>Report</button>
                            {state.showDelete && <button onClick={()=>deleteReview()}>Delete</button>}
                        </div>
                    }
               
                </div>
               
            </div>

            {/* <div className="flex-row2">
                <p>{country}</p>
                <p>{FormatTimePassedUtc(timestamp)}</p>
            </div> */}

            <div className="flex-row2">
                {rate && rate.map((data, index) => (
                    <div key={index}>
                    <HbrStarIcon width={"1.8em"} height={"1.8em"} fillColour={"orange"}/>
                    </div>
                ))}
            </div>

            <h3>{book_title && book_title}</h3>
            <pre>{message}</pre>
            {state.showReplyBox && 
                <div className="replyreviewtextboxholder flex-row2" ref={replyBoxRef}>
                    <CustomTextArea 
                    value={state.replyText} 
                    onChange={e => dispatch({type: actionConsts.REPLY_TEXT, payload: e.target.value})}
                    textareaLineHeight={48} 
                    hint={`Reply @${userNameOnReview}`} 
                    maxRows={6}/>
                    <HbrSendIcon width={"2em"} height={"2em"} fillColour={"#1C1F2E"} handleClick={()=>sendReply()}/>
                </div>
            }

           {memoizedReplies && 
                <div className="displayreplycount" style={{position:"relative"}}>
                    {memoizedReplies.length > 1 ? 
                    <p style={{color:"#0E78F9", fontWeight:"bold", caretColor:"transparent", cursor:"pointer"}} onClick={()=>setShowReplyContent(true)}>
                        {`${memoizedReplies.length} Replies`}
                    </p> 
                    
                    : memoizedReplies.length === 1 ?  
                    <p style={{color:"#0E78F9",fontWeight:"bold", caretColor:"transparent", cursor:"pointer"}} onClick={()=>setShowReplyContent(true)}>
                        {`${memoizedReplies.length} Reply`}
                    </p> 
                    : ""
                    }

                    {showReplyContent && 
                        <div className="replytoreview flex-column1" ref={repliesViewRef}>
                            <HbrCancel width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>setShowReplyContent(false)}/>
                          {memoizedReplies && memoizedReplies.map((data,index) => (
                              <ReplyReviewContent 
                              key={index}
                              userName={data.name}
                              email={data.email}
                              message={data.message}
                              userReplied={data.userReplied}
                              timestamp={data.timestamp}
                              replyID={data.replyID}
                              reviewID={data.reviewID}
                              />
                          ))}
          
                      </div>
                    }
                </div>
           }

            <div className="visiblereplyonreview flex-column1" style={{alignItems:"flex-end", width:"80%"}}>
                {replies && replies.length > 0 && 
                    <ReplyReviewContent 
                        userName={replies[replies.length-1]?.name || ""}
                        email={replies[replies.length-1]?.email || ""}
                        message={replies[replies.length-1]?.message || ""}
                        userReplied={replies[replies.length-1]?.userReplied || ""}
                        timestamp={replies[replies.length-1]?.timestamp || ""}
                        replyID={replies[replies.length-1]?.replyID || ""}
                        reviewID={replies[replies.length-1]?.reviewID || ""}
                    />
                }
            </div>
          
        </div>
     );
}
export default ReviewContent;